import { Radio, Loader2 } from 'lucide-react'
import { cn, timeAgo } from '@/lib/utils'
import { useRoutes } from '@/hooks/useApi'

export function RoutesPanel() {
  const { data, isLoading } = useRoutes()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-32 text-text-muted text-sm">
        <Loader2 className="h-4 w-4 animate-spin mr-2" /> Loading routes...
      </div>
    )
  }

  const routes = data?.routes || []

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Radio className="h-5 w-5 text-accent" />
        <h2 className="text-lg font-bold text-white">Data Route Registry</h2>
        <span className="text-xs text-text-muted ml-2">{routes.length} routes</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/10 text-left text-xs text-text-muted uppercase tracking-wider">
              <th className="py-2 px-3">Route ID</th>
              <th className="py-2 px-3">Source</th>
              <th className="py-2 px-3">Destination</th>
              <th className="py-2 px-3">Type</th>
              <th className="py-2 px-3">Classification</th>
              <th className="py-2 px-3">Status</th>
              <th className="py-2 px-3">Last Seen</th>
            </tr>
          </thead>
          <tbody>
            {routes.map((r) => (
              <tr key={r.route_id} className="border-b border-white/5 hover:bg-white/[0.02]">
                <td className="py-2.5 px-3 font-mono text-xs text-accent">{r.route_id}</td>
                <td className="py-2.5 px-3 text-xs text-white">{r.source}</td>
                <td className="py-2.5 px-3 text-xs text-white">{r.destination}</td>
                <td className="py-2.5 px-3 text-xs text-text-muted">{r.route_type}</td>
                <td className="py-2.5 px-3">
                  <span className={cn(
                    'text-[10px] px-1.5 py-0.5 rounded font-medium',
                    r.classification === 'external' ? 'bg-amber-500/10 text-amber-400' :
                    r.classification === 'platform' ? 'bg-blue-500/10 text-blue-400' :
                    'bg-emerald-500/10 text-emerald-400'
                  )}>
                    {r.classification}
                  </span>
                </td>
                <td className="py-2.5 px-3">
                  <span className={cn(
                    'text-[10px] px-1.5 py-0.5 rounded font-medium',
                    r.status === 'active' ? 'bg-emerald-500/10 text-emerald-400' :
                    r.status === 'degraded' ? 'bg-amber-500/10 text-amber-400' :
                    'bg-zinc-500/10 text-zinc-400'
                  )}>
                    {r.status}
                  </span>
                </td>
                <td className="py-2.5 px-3 text-xs text-text-muted">
                  {r.last_seen ? timeAgo(new Date(r.last_seen)) : 'never'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {routes.length === 0 && (
        <div className="text-center text-text-muted text-sm py-8">No routes configured</div>
      )}
    </div>
  )
}
